var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { attachRegionsHover, attachNearestHover } from '../core/interaction';
import { registerDashboard } from '../../registryCore';
import { createWidgetGroup, num, setState } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { forceDirectedLayout } from '../../../diagram/layouts';
registerDashboard('networkChart', function (props, app) {
    var _a, _b;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 200);
    var nodes = (_a = props.nodes) !== null && _a !== void 0 ? _a : [
        { id: 'a', label: 'A' },
        { id: 'b', label: 'B' },
        { id: 'c', label: 'C' },
        { id: 'd', label: 'D' },
    ];
    var edges = (_b = props.edges) !== null && _b !== void 0 ? _b : [
        { from: 'a', to: 'b' },
        { from: 'b', to: 'c' },
        { from: 'a', to: 'd' },
        { from: 'd', to: 'c' },
    ];
    var group = createWidgetGroup(app, 'networkChart', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var positions = forceDirectedLayout(nodes, edges, { width: width, height: height, iterations: 50, seed: 7 });
    edges.forEach(function (e) {
        var a = positions.get(e.from);
        var b = positions.get(e.to);
        if (!a || !b)
            return;
        group.add(app.line({ x: a.x, y: a.y, x2: b.x - a.x, y2: b.y - a.y, stroke: getActiveDashboard().chartGrid, strokeWidth: 1, listening: false }));
    });
    nodes.forEach(function (n) {
        var _a;
        var p = positions.get(n.id);
        if (!p)
            return;
        group.add(app.circle({ x: p.x - 10, y: p.y - 10, radius: 10, fill: getActiveDashboard().primary, listening: false }), app.text({ text: (_a = n.label) !== null && _a !== void 0 ? _a : n.id, x: p.x - 8, y: p.y + 16, fontSize: 9, fill: getActiveDashboard().text, listening: false }));
    });
    attachNearestHover(app, group, props, { x: 0, y: 0, width: width, height: height }, nodes
        .map(function (n) {
        var _a;
        var p = positions.get(n.id);
        if (!p)
            return null;
        return { x: p.x, y: p.y, label: (_a = n.label) !== null && _a !== void 0 ? _a : n.id };
    })
        .filter(function (p) { return p != null; }));
    setState(group, { width: width, height: height, nodes: nodes, edges: edges });
    return group;
});
registerDashboard('timeline', function (props, app) {
    var _a;
    var width = num(props, 'width', 320);
    var height = num(props, 'height', 120);
    var events = (_a = props.events) !== null && _a !== void 0 ? _a : [
        { label: 'Kickoff', start: 0, end: 2 },
        { label: 'Build', start: 2, end: 8 },
        { label: 'Launch', start: 8, end: 10 },
    ];
    var group = createWidgetGroup(app, 'timeline', props);
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(events.map(function (e) { var _a, _b; return (_b = (_a = e.end) !== null && _a !== void 0 ? _a : e.start) !== null && _b !== void 0 ? _b : 0; })), false), [10], false));
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    group.add(app.line({ x: 20, y: height / 2, x2: width - 40, y2: 0, stroke: getActiveDashboard().timelineLine, strokeWidth: 2, listening: false }));
    events.forEach(function (ev, i) {
        var _a, _b;
        var start = (_a = ev.start) !== null && _a !== void 0 ? _a : i * 2;
        var end = (_b = ev.end) !== null && _b !== void 0 ? _b : start + 1;
        var x = 20 + ((start / max) * (width - 60));
        var w = ((end - start) / max) * (width - 60);
        group.add(app.roundedRect({ x: x, y: height / 2 - 14, width: Math.max(w, 20), height: 28, cornerRadius: 4, fill: getActiveDashboard().series[i % getActiveDashboard().series.length], listening: false }), app.text({ text: ev.label, x: x + 4, y: height / 2 - 6, fontSize: 10, fill: getActiveDashboard().text, listening: false }));
    });
    attachRegionsHover(app, group, props, width, height, events.map(function (ev, i) {
        var _a, _b;
        var start = (_a = ev.start) !== null && _a !== void 0 ? _a : i * 2;
        var end = (_b = ev.end) !== null && _b !== void 0 ? _b : start + 1;
        var x = 20 + (start / max) * (width - 60);
        var w = ((end - start) / max) * (width - 60);
        return { x: x, y: height / 2 - 14, width: Math.max(w, 20), height: 28, label: ev.label };
    }));
    setState(group, { width: width, height: height, events: events });
    return group;
});
registerDashboard('ganttChart', function (props, app) {
    var _a;
    var width = num(props, 'width', 360);
    var height = num(props, 'height', 200);
    var tasks = (_a = props.tasks) !== null && _a !== void 0 ? _a : [
        { label: 'Design', start: 0, end: 3 },
        { label: 'Develop', start: 2, end: 8 },
        { label: 'Test', start: 7, end: 10 },
        { label: 'Ship', start: 10, end: 12 },
    ];
    var group = createWidgetGroup(app, 'ganttChart', props);
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(tasks.map(function (t) { return t.end; })), false), [12], false));
    var rowH = height / tasks.length;
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    tasks.forEach(function (t, i) {
        var _a;
        var y = i * rowH + 8;
        var x = 80 + (t.start / max) * (width - 100);
        var w = ((t.end - t.start) / max) * (width - 100);
        group.add(app.text({ text: t.label, x: 4, y: y + 4, fontSize: 11, fill: getActiveDashboard().text, listening: false }), app.roundedRect({ x: x, y: y, width: Math.max(w, 8), height: rowH - 16, cornerRadius: 3, fill: (_a = t.color) !== null && _a !== void 0 ? _a : getActiveDashboard().series[i % getActiveDashboard().series.length], listening: false }));
    });
    attachRegionsHover(app, group, props, width, height, tasks.map(function (t, i) {
        var y = i * rowH + 8;
        var x = 80 + (t.start / max) * (width - 100);
        var w = ((t.end - t.start) / max) * (width - 100);
        return { x: x, y: y, width: Math.max(w, 8), height: rowH - 16, label: "".concat(t.label, " (").concat(t.start, "-").concat(t.end, ")") };
    }));
    setState(group, { width: width, height: height, tasks: tasks });
    return group;
});
